export type UpdateBillingProfilePaymentMethodFn = (payload: {
    request: {
        billingProfileId: string;
        stripePaymentMethodId: string;
        setAsDefault?: boolean;
    };
    accessToken: string;
}) => Promise<unknown>;

export function initUpdateBillingProfilePaymentMethodFn({
    baseUrl,
}: {
    baseUrl: string;
}): UpdateBillingProfilePaymentMethodFn {
    const href =
        'billing/v1/billing-profiles/{billingProfileId}/payment-methods';
    return async ({
        request: { billingProfileId, stripePaymentMethodId, setAsDefault },
        accessToken,
    }) => {
        const url = `${baseUrl}/${href.replace('{billingProfileId}', billingProfileId)}${setAsDefault ? `?${new URLSearchParams({ setAsDefault: setAsDefault.toString() })}` : ''}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                Accept: 'application/json; charset=utf-8',
                Authorization: 'Bearer {accessToken}'.replace(
                    '{accessToken}',
                    accessToken,
                ),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ stripePaymentMethodId }),
        });
        if (!response.ok) return Promise.reject(await response.json());
        return response.json();
    };
}
